module.exports = __webpack_public_path__ + "img/heading_uk.49e50cea.svg";